export function filterEmptyParams(
  param: [string, string | undefined],
): param is [string, string] {
  return Number(param[1]?.length) > 0;
}
